module.exports = __webpack_public_path__ + "media/images/pic/best-place-98188cb60c9e55d4218493d7e0029e38.png";